<template>
  <ODialog ref="dialog" hideWhenLoading>
    <v-card v-if="org != null && vehicle != null && trips != null">
      <ODialogBar title="Ajustar Motorista" @close="dismiss" />
      <v-card-text class="pa-3">
        <OCapCont class="pa-3" label="Veículo">
          #{{ vehicle.id }} {{ vehicle.code }}
        </OCapCont>

        <OAutocomplete
          class="pa-3"
          label="Motorista de destino"
          v-model="toDriverId"
          placeholder="Selecione..."
          :items="allDrivers"
        />
      </v-card-text>
      <v-card-text class="pa-6 amber">
        <v-btn small @click="copyToClipboard" class="mb-4">
          <v-icon small>mdi-clipboard</v-icon>
          Copiar para o Clipboard
        </v-btn>
        <pre class="mono">{{ command }}</pre>
      </v-card-text>
    </v-card>
  </ODialog>
</template>

<script>
import { Org, OrgApi } from '@/models'

export default {
  data() {
    return {
      tripIds: null,
      orgId: null,
      trips: [],
      org: null,
      vehicle: null,
      allDrivers: [],
      toDriverId: null
    }
  },
  computed: {
    command() {
      if (this.org == null || this.vehicle == null) return ''
      let vid = this.vehicle.id
      let did = this.toDriverId
      let fd = this.fromDate
      let ud = this.untilDate
      let orgCode = this.org.name

      let pieces = [
        'assigner move-driver',
        `  --fromVehicleId ${vid}`,
        did && `  --toDriverId ${did}`,
        `  --fromDate ${fd}`,
        ud && `  --untilDate ${ud}`,
        `  --conn $(ro conn ${orgCode})`
      ]

      return pieces.filter((x) => x != null).join('\n')
    }
  },
  methods: {
    open(tripIndexes, tripIds, orgId) {
      this.orgId = orgId
      this.tripIds = tripIds
      this.$refs.dialog.$loading(() => this.fetchData())
      return this.$refs.dialog.$open()
    },

    dismiss() {
      this.$refs.dialog.$dismiss()
    },

    async fetchData() {
      // Se tripIndexes tem gaps, informa que não será possível fazer
      this.org = await Org.findById(this.orgId)

      let sorted = this.tripIds.sort()
      let fetcher = new OrgApi(this.orgId)
      let first = await fetcher.get('trips/' + sorted[0])
      let last = await fetcher.get('trips/' + sorted[sorted.length - 1])
      let afterLast = await fetcher.get('trips', {
        vehicleId: last.vehicleId,
        fromDate: last.endTimestamp,
        limit: 1,
        order: 'startTimestamp asc'
      })

      if (afterLast.count > 0) afterLast = afterLast.rows[0]

      this.fromDate = first.startTimestamp
      this.untilDate = afterLast && afterLast.startTimestamp
      this.vehicle = first.vehicle
      this.trips = [first, last, afterLast]

      let drivers = await fetcher.get('drivers', { mini: true })
      this.allDrivers = drivers.map((x) => {
        let chips = x.tags && x.tags.map((t) => ({ text: t }))
        return { value: x.id, text: x.name, chips }
      })
      // Calcular datas
      // Se o intervalo é razoável (e.g. no máx 5 dias), já faz o
      // preview
      // senão informa que não será possível fazer
      // Depois do preview
    },

    copyToClipboard() {
      let str = this.command.replaceAll(/\n/g, ' ').replaceAll(/\s+/g, ' ')
      navigator.clipboard.writeText(str)
      this.$snack(`Comando copiado`)
    }
  }
}
</script>

<style></style>
